import React, { useState, useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box, Typography } from "@mui/material";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import { StatusControl } from "../../uiControls/statusControl";
import { FileTypeColumnUpdate } from "./fileTypeColumnUpdate";

const initialFileTypeIsValid = {
  name: "",
  description: "",
  fileColumns: "",
};

export const FileTypeUpdate = (props) => {
  const { setUpdateOpen, fileTypeEdit, setFileTypeEdit, fileTypeAttributes } =
    props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateFileType } = useHttpRequests();

  const [fileTypeDetails, setFileTypeDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    fileTypeAttributes
  );
  const [fileTypeColumns, setFileTypeColumns] = useState(
    fileTypeAttributes?.fileColumns
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialFileTypeIsValid
  );

  const updateFileTypeDetailsValue = (_key, value) => {
    setFileTypeDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateFileTypeColumnsValue = (_key, fieldName, fieldValue) => {
    if (_key) {
      const dataIndex = fileTypeColumns?.findIndex(
        (obj) => obj.columnKey === _key
      );
      if (dataIndex >= 0) {
        fileTypeColumns[dataIndex][fieldName] = fieldValue;
        setFileTypeColumns(fileTypeColumns);
      }
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const cancelFileTypeHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setFileTypeEdit(false);
    setUpdateOpen(false);
  };

  const validateFileTypeDetails = () => {
    setIsValid(initialFileTypeIsValid);

    var errorSummary = "";

    if (!fileTypeColumns.find((row) => row.active)) {
      updateErrorMessage("fileColumns", "File columns", "Enter ");
      errorSummary += "A file type must have atleast one active column.";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      let dataObj = fileTypeDetails;
      dataObj["fileColumns"] = fileTypeColumns;

      const getUpdateFileTypeResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "File type updated successfully!",
          })
        );
        setTimeout(() => {
          cancelFileTypeHandler();
        }, 2000);
      };

      if (fileTypeEdit) {
        updateFileType(
          {
            url: "FileTypes/" + dataObj["fileTypeKey"],
            method: "PUT",
            body: dataObj,
          },
          getUpdateFileTypeResponse
        );
      } else {
        delete dataObj["fileTypeKey"];
        updateFileType(
          { url: "FileTypes", body: dataObj },
          getUpdateFileTypeResponse
        );
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            overflow: "auto",
          }}
        >
          <MessageDisplay />
          <Typography>
            <label>File Type:</label> {fileTypeDetails.name}
          </Typography>
          <Typography>
            <label>Description:</label> {fileTypeDetails.description}
          </Typography>

          {/*<StatusControl
            label="Active"
            isRequired={false}
            fieldName={"active"}
            active={fileTypeDetails.active}
            updateStatusValue={updateFileTypeDetailsValue}
        />*/}

          <FileTypeColumnUpdate
            data={fileTypeColumns}
            updateFileTypeColumnsValue={updateFileTypeColumnsValue}
          />

          <SaveCancel
            cancelCall={() => cancelFileTypeHandler()}
            saveCall={() => validateFileTypeDetails()}
          />
        </div>
      </Box>
    </>
  );
};
